import React from "react";
import { ethers, providers, BigNumber, utils } from "ethers";
import "./App.css";
import Kingdom from "./abi/Kingdom.json";
import Dashapp from "./dash-app";
import DashTreasury from "./dash-treasury";
import DashCommunity from "./dash-community";
import Home from "./Home";
import {
  BrowserRouter as Router,
  Link,
  Routes,
  Route,
  Switch,
} from "react-router-dom";
import * as Parallel from "async-parallel";
import Pegination from "./pegination";

// const SUPPORTED_NETWORKS = ["matic", "maticmum"];
// const SUPPORTED_NETWORK_LONG = "Matic Mainnet, Matic Mumba";

class App extends React.Component {
  async componentWillMount() {
    console.log("starting");
    this.initVar();
    this.loadContractDetails();
  }

  async loadContractDetails() {
    let { network, wallet, provider } = await this.initJustEther();
    let { readerContract } = await this.initReaderContract(
      network,
      provider,
      wallet
    );
    this.fetchContractInfo(readerContract);
    await this.initWriterContract();
  }

  async initVar() {
    // this.state.propsInfo["writerContract"] = this.state.writerContract;
    this.state.propsInfo["pawnsOfUser"] = this.state.pawns;
    this.state.propsInfo["perNodeReward"] = this.state.perNodeReward;
    this.state.propsInfo["nodePrice"] = this.state.nodePrice;
    this.state.propsInfo["perNodeRewardAfterBreakEven"] =
      this.state.perNodeRewardAfterBreakEven;
    // this.state.propsInfo["nodeNames"] = this.state.nodeNames;
    // this.state.propsInfo["nodesCreateTime"] = this.state.nodesCreateTime;
    // this.state.propsInfo["nodesLastClaimTime"] = this.state.nodesLastClaimTime;
    // this.state.propsInfo["nodesRewards"] = this.state.nodesRewards;
    this.state.propsInfo["decimals"] = this.state.decimals;
    this.state.propsInfo["nodeNumbersOfUser"] = this.state.nodeNumbersOfUser;
    this.state.propsInfo["totalNodes"] = this.state.totalNodes;
    this.state.propsInfo["walletAddress"] = this.state.address;
  }

  constructor(props) {
    super(props);
    this.state = {
      address: "",
      totalNodes: 0,
      balance: "",
      decimals: 0,
      pawns: 0,
      nodeNumbersOfUser: 0,
      nodeNameToSet: "",
      nodeNames: "",
      nodesRewards: [],
      writerContract: null,
      readerContract: null,
      loadedValues: false,
      nodesCreateTime: "",
      nodesLastClaimTime: "",
      RealTimeReards: [],
      propsInfo: {},
      network: null,
      perNodeRewardAfterBreakEven: "",
      nodePrice: "",
      perNodeReward: "",
    };
    this.createNode = this.createNode.bind(this);
    this.textInput = this.textInput.bind(this);
    this.cashoutAllNodes = this.cashoutAllNodes.bind(this);
    this.cashoutOneNode = this.cashoutOneNode.bind(this);
    this.updateRewardsLocal = this.updateRewardsLocal.bind(this);
    this.compound = this.compound.bind(this);
  }

  async componentDidMount() {
    this.interval = setInterval(() => this.updateRewardsLocal(), 10000);
  }

  async compound(event) {
    event.preventDefault();
    console.log(this.state.nodeNameToSet);
    try {
      const txnResponse = await this.state.writerContract.AutoCompound(
        this.state.nodeNameToSet
      );
      const txnReceipt = await txnResponse.wait();
      console.log(txnReceipt);
      this.loadContractDetails();
    } catch (e) {
      console.log(e.data);
      alert(e.data.message);
    }
  }

  async approval() {
    // console.log(this.state.nodeNameToSet);
    try {
      const txnResponse = await this.state.writerContract.approve();
      const txnReceipt = await txnResponse.wait();
      console.log(txnReceipt);
      this.loadContractDetails();
    } catch (e) {
      console.log(e.data);
      alert(e.data.message);
    }
  }

  async createNode(event) {
    event.preventDefault();
    // await this.approval()
    console.log(this.state.nodeNameToSet);
    try {
      const txnResponse = await this.state.writerContract.createNodeWithTokens(
        this.state.nodeNameToSet
      );
      const txnReceipt = await txnResponse.wait();
      console.log(txnReceipt);
      this.loadContractDetails();
    } catch (e) {
      console.log(e.data);
      alert(e.data.message);
    }
  }

  async cashoutAllNodes(event) {
    event.preventDefault();
    const txnResponse = await this.state.writerContract.cashoutAll();
    const txnReceipt = await txnResponse.wait();
    console.log(txnReceipt);
    this.loadContractDetails();
  }

  async cashoutOneNode(createTime) {
    console.log(createTime);
    // event.preventDefault();
    const txnResponse = await this.state.writerContract.cashoutReward(
      createTime
    );
    const txnReceipt = await txnResponse.wait();
    console.log(txnReceipt);
    this.loadContractDetails();
  }

  async textInput(event) {
    let val = event.target.value;
    console.log(val);
    !val.includes("#") && this.setState({
      nodeNameToSet: val,
    });
  }

  async initWriterContract() {
    try {
      const wallet = await this.state.provider.getSigner();
      this.setState({
        wallet,
      });
      const networkData = Kingdom.networks;
      const networkId = String(this.state.network.chainId);
      console.log("network id ", networkId);
      console.log("network data ", networkData);
      const contractAddress = networkData[networkId.toString()]["address"];
      const writerContract = new ethers.Contract(
        contractAddress,
        Kingdom.abi,
        wallet
      );
      this.setState({
        writerContract,
      });
      console.log("initiated writer contract");
      // this.state.propsInfo["writerContract"] = this.state.writerContract;
    } catch (e) {
      console.log("error occured");
      console.log(e);
    }
  }

  async fetchBalanceOfUser() {
    const balanceOfThisPerson = await this.state.readerContract.balanceOf(
      this.state.address
    );
    // console.log("balance of this person -->", balanceOfThisPerson.toString());
    this.setState({
      balance: balanceOfThisPerson.toString(),
    });
    const balanceInPawn = balanceOfThisPerson.div(
      BigNumber.from((10 ** this.state.decimals).toString())
    );
    // console.log(balanceInPawn.toString());
    this.setState({
      pawns: balanceInPawn.toString(),
    });
    // this.state.propsInfo["balanceOfUser"] = this.state.balance;
    this.state.propsInfo["pawnsOfUser"] = this.state.pawns;
  }

  async fetchBasicInfoAboutContract(readerContract_) {
    // console.log("ccc" ,readerContract_);
    const contractName = readerContract_.name();
    this.state.propsInfo["contractName"] = contractName;

    const perNodeReward = await readerContract_.getRewardPerNode();
    this.setState({
      perNodeReward: perNodeReward.toString(),
    });

    const nodePrice = await readerContract_.getNodePrice();
    this.setState({
      nodePrice: nodePrice.toString(),
    });

    const perNodeRewardAfterBreakEven =
      await readerContract_.getRewardPerNodeAfterBreakEven();
    this.setState({
      perNodeRewardAfterBreakEven: perNodeRewardAfterBreakEven.toString(),
    });

    this.state.propsInfo["perNodeReward"] = this.state.perNodeReward;
    this.state.propsInfo["nodePrice"] = this.state.nodePrice;
    this.state.propsInfo["perNodeRewardAfterBreakEven"] =
      this.state.perNodeRewardAfterBreakEven;
  }

  async fetchNodesInfo(readerContract_) {
    const nodeNames = await readerContract_.getNodesNames({
      from: this.state.address,
    });
    // console.log("55555555555555555555555555555555555555555555555555555")
    console.log(nodeNames.split("#"));
    this.setState({ nodeNames });

    const nodesCreateTime = await readerContract_.getNodesCreatime({
      from: this.state.address,
    });
    console.log(nodesCreateTime.split("#"));
    this.setState({ nodesCreateTime });

    const nodesLastClaimTime = await readerContract_.getNodesLastClaims({
      from: this.state.address,
    });
    console.log(nodesLastClaimTime.split("#"));
    this.setState({ nodesLastClaimTime });

    const rewardsinPawns = await readerContract_.getNodesRewards({
      from: this.state.address,
    });
    this.setState({ rewardsinPawns });
    var nodesRewards = [];
    for (var i = 0; i < rewardsinPawns.split("#").length; i++) {
      var temp = parseInt(rewardsinPawns.split("#")[i]) / parseInt(10 ** 18);
      nodesRewards.push(temp);
    }
    console.log("reward --> ", nodesRewards);
    this.setState({ nodesRewards }); // rewardsinPawns
  }

  async fetchContractInfo(readerContract_) {
    try {
      this.setState({
        loadedValues: false,
      });

      await this.fetchBasicInfoAboutContract(readerContract_);

      const decimals = await readerContract_.decimals();
      this.setState({
        decimals,
      });

      this.fetchBalanceOfUser();

      const nodeNumbersOfUser = await readerContract_.getNodeNumberOf(
        this.state.address
      );
      this.setState({ nodeNumbersOfUser: nodeNumbersOfUser.toNumber() });

      const totalNodes = await readerContract_.getTotalCreatedNodes();
      this.setState({ totalNodes: totalNodes.toNumber() });
      this.state.propsInfo["decimals"] = this.state.decimals;
      this.state.propsInfo["nodeNumbersOfUser"] = this.state.nodeNumbersOfUser;
      this.state.propsInfo["totalNodes"] = this.state.totalNodes;

      this.fetchNodesInfo(readerContract_);

      this.setState({ loadedValues: true });
    } catch (e) {
      console.log(e);
    }
  }

  async initJustEther() {
    if (!window.ethereum) {
      throw new Error(
        "No web3 provider found. Please install metamask browser extension."
      );
    }
    try {
      await window.ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const wallet = provider.getSigner();
      this.setState({ wallet });
      this.setState({ provider });
      const network = await provider.getNetwork();
      console.log("---------------");
      console.log(network);
      this.setState({ network });
      console.log(this.state.network);
      if (this.state.network.chainId != 250) {
        alert(`Only ${"Fantom Opera"} network is currently supported. Switch your wallet connection and refresh the webpage.`)
        console.log("error--");
      }
      this.setState({ address: await wallet.getAddress() });
      this.state.propsInfo["walletAddress"] = this.state.address;
      console.log("initJustEther successfully ran");
      return { network, wallet, provider };
    } catch (e) {
      console.log(e);
    }
  }

  async initReaderContract(network_, provider_, wallet) {
    try {
      const networkData = Kingdom.networks;
      // console.log("------------------------------")
      // console.log(this.state.network)
      const networkId = network_.chainId;
      const contractAddress = networkData[networkId.toString()]["address"];
      const readerContract = new ethers.Contract(
        contractAddress,
        Kingdom.abi,
        provider_
      );
      this.setState({
        readerContract,
      });
      // this.state.propsInfo["readerContract"] = this.state.readerContract;
      console.log("initiated reader contract");
      return { readerContract };
    } catch (e) {
      console.log(e);
    }
  }

  async updateRewardsLocal() {
    if (this.state.loadedValues) {
      console.log("updating ..");
      var createTime = this.state.nodesCreateTime.split("#");
      // console.log(createTime);
      var oldRewards = this.state.rewardsinPawns.split("#");
      // console.log(oldRewards);
      var lastClaimTime = this.state.nodesLastClaimTime.split("#");
      var daysToBreakEven = parseInt((parseInt(this.state.nodePrice) * 1.0) /parseInt(this.state.perNodeReward));
      // console.log(lastClaimTime);

      var numberOfNodes = lastClaimTime.length;
      var currReward = [];
      var sum_ = 0;
      for (var i = 0; i < numberOfNodes; i++) {
        console.log("------------------------------");
        // console.log(Date.now())
        var currentTime = Date.now() / 1000;
        var tempReward = 0;

        /////////////////////////////////////////////////////
        
        if ((currentTime - createTime[i]) / (24 * 60 * 60) >= daysToBreakEven) {
          console.log("going here...........................",daysToBreakEven,(currentTime - createTime[i]) / (24 * 60 * 60),currentTime );
          // node.cashoutFee = thirdStageCashoutFee;
          if (
            lastClaimTime[i] <=
            createTime[i] + daysToBreakEven * (24 * 60 * 60)
          ) {
            console.log("1*********************************");
            tempReward +=
              (this.state.perNodeReward *
                (createTime[i] +
                  daysToBreakEven * (24 * 60 * 60) -
                  lastClaimTime[i])) ;
            tempReward +=
              (this.state.perNodeRewardAfterBreakEven *
                (currentTime -
                  createTime[i] -
                  daysToBreakEven * (24 * 60 * 60)));
            tempReward = tempReward/ (24*60*60);
            console.log(
              "2______________________",
              daysToBreakEven,
              currentTime,
              createTime[i],
              daysToBreakEven * 24 * 60 * 60,
              currentTime - createTime[i] - daysToBreakEven * (24 * 60 * 60)
            );
          }

          if (lastClaimTime[i] > createTime[i] + daysToBreakEven * (24 * 60 * 60) ) {
            tempReward += (this.state.perNodeRewardAfterBreakEven) *(currentTime -  lastClaimTime[i]) /(24 * 60 * 60);
          }
        }
        if ((currentTime - createTime[i]) / (24 * 60 * 60) < daysToBreakEven) {
          console.log(
            "not going there.. ->",
            daysToBreakEven,
            (currentTime - createTime[i]) / (24 * 60 * 60),
            this.state.perNodeReward
          );
          tempReward =
            (this.state.perNodeReward * (currentTime - lastClaimTime[i])) /
            (24 * 60 * 60);
        }

        // if (lastClaimTime[i] == createTime[i]) {
        //   tempReward =(this.state.perNodeReward * (currentTime - lastClaimTime[i])) /(24 * 60 * 60);
        // }
        ///////////////////////////////////////////////////
        console.log(tempReward, this.state.nodePrice, this.state.perNodeReward);
        // var tempReward = (1.0 * parseInt(this.state.perNodeReward) * (currentTime - lastClaimTime[i])) / (24 * 60 * 60) ;
        // console.log(currentTime - lastClaimTime[i], this.state.perNodeReward, tempReward);
        // console.log(oldRewards[i]);
        // console.log(BigNumber.from(tempReward));
        // var rewardNow = (parseInt(tempReward) +( parseInt(oldRewards[i])).toString();
        var rewardNow =
          (parseFloat(tempReward) * 1.0) / parseInt(10 ** 18) +
          parseFloat(this.state.nodesRewards[i]);
        sum_ += (parseInt(tempReward) * 1.0) / parseInt(10 ** 18);
        // var rewardNow = BigNumber.from(tempReward).add(BigNumber.from(oldRewards[i])).toString();
        currReward.push(rewardNow);
      }
      console.log("sum-->", sum_);
      // this.setState({nodesRewards: currReward})
      console.log(currReward);

      this.setState({ RealTimeReards: currReward });
      // this.setState({nodesRewards: currReward});
      // this.state.propsInfo["RealTimeReards"] = this.state.RealTimeReards;
    }
  }

  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => (
                <Dashapp
                  {...props}
                  propsInfo={this.state.propsInfo}
                  nodeNames={this.state.nodeNames}
                  nodesCreateTime={this.state.nodesCreateTime}
                  nodesLastClaimTime={this.state.nodesLastClaimTime}
                  nodesRewards={this.state.nodesRewards}
                  RealTimeReards={this.state.RealTimeReards}
                  createNode={this.createNode}
                  textInput={this.textInput}
                  cashoutAllNodes={this.cashoutAllNodes}
                  cashoutOneNode={this.cashoutOneNode}
                  compound={this.compound}
                  nodeNameToSet={this.state.nodeNameToSet}
                />
              )}
            />
            <Route path="/dashtreasury" component={DashTreasury} />
            <Route path="/dashcommunity" component={DashCommunity} />
            <Pegination />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
